import { AxiosResponse } from "axios";
import API from "../api";

import { Container } from "../models/shipment.container";
import { GetAndCountAll } from "./_base";
import BaseService from "./_base.service";

const endpoint = "shipments/containers";

const ShipmentContainerService = {
  ...BaseService<Container>({ endpoint }),
  async getAll(options: any): Promise<AxiosResponse<GetAndCountAll<Container>>> {
    return await API.get(`/${endpoint}/companies/getAll`, { params: options });
  },
  async delete(id: number): Promise<AxiosResponse<number>> {
    return await API.delete(`/${endpoint}/${id}`);
  },

};

export default ShipmentContainerService;
